import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      REQUIRED_INFORMATION_MISSING:
        "Noen av de påkrevde opplysningene mangler. Vennligst gå tilbake og fyll ut alle feltene.",
      GO_BACK: "Gå tilbake",
    },
    se: {
      REQUIRED_INFORMATION_MISSING:
        "Några av de obligatoriska uppgifterna saknas. Gå tillbaka och fyll i alla fält.",
      GO_BACK: "Gå tillbaka",
    },
    dk: {
      REQUIRED_INFORMATION_MISSING:
        "Nogle af de påkrævede oplysninger mangler. Gå venligst tilbage og udfyld alle felterne.",
      GO_BACK: "Gå tilbage",
    },
  } as const
)[language];
